import { MRT_GlobalFilterTextField as GlobalFilterTextField } from "material-react-table";
import { Button } from "@mui/material";

import CustomTable from "components/common/table/CustomTable";
import useInsurances from "./hooks/useInsurances";
import InsuranceModal from "./modals/insuranceModal";
import DeleteConfirmationModal from "./modals/deleteConfirmationModal";

const Insurances = () => {
  const {
    columns,
    insurances,
    isFetching,
    showInsuranceModal,
    handleAddInsurance,
    showDeleteConfirmationModal,
  } = useInsurances();

  return (
    <div>
      <div id="userTable">
        <div className="trans-table__container">
          <CustomTable
            data={insurances || []}
            columns={columns}
            options={{
              enableTopToolbar: true,
              state: {
                isLoading: isFetching,
                showGlobalFilter: true,
                showColumnFilters: true,
              },
              renderTopToolbar: ({ table }) => (
                <div
                  className="d-flex justify-between"
                  style={{
                    padding: "10px",
                    borderBottom: "1px solid #e0e0e0",
                    gap: "10px",
                  }}
                >
                  <GlobalFilterTextField table={table} />
                  <Button
                    onClick={handleAddInsurance}
                    size="small"
                    color="secondary"
                    variant="contained"
                  >
                    + Add Insurance
                  </Button>
                </div>
              ),
            }}
          />
          {showInsuranceModal && <InsuranceModal />}
          {showDeleteConfirmationModal && <DeleteConfirmationModal />}
        </div>
      </div>
    </div>
  );
};

export default Insurances;
